const DEFAULT_CREATION_MESSAGE = "Started";

export enum LoggerLevel {
  DEBUG = "debug",
  INFO = "info",
  WARN = "warn",
  ERROR = "error",
}

// Fork of: https://github.com/epeli/node-clim
// Usage:
//
// import moduleLogger from './logger'
// var logger = moduleLogger("file.js");
// let logger = moduleLogger("method", moduleLogger);
class Logger {
  private prefixes: string[] = [];

  constructor(
    private prefix: string,
    private parent: Logger | undefined,
    printOnCreation: string,
    printOnCreationLevel: LoggerLevel
  ) {
    // if method is a path, take the last section (file name)
    let lastSlashWin = this.prefix.lastIndexOf("\\");
    let lastSlashUnix = this.prefix.lastIndexOf("/");
    let lastSlash = lastSlashWin > -1 ? lastSlashWin : lastSlashUnix;
    if (lastSlash > -1) {
      this.prefix = this.prefix.substr(lastSlash + 1);
    }

    if (this.parent) {
      this.prefixes = this.prefixes.concat(this.parent.prefixes);
    }

    this.prefixes.push(`[${prefix}]`);
  }

  debug(message: string) {
    this.logMessage(LoggerLevel.DEBUG, this.prefixes, message);
  }
  info(message: string) {
    this.logMessage(LoggerLevel.INFO, this.prefixes, message);
  }
  warn(message: string, error?: Error) {
    if (error) {
      message += "\n" + error.toString();
    }

    this.logMessage(LoggerLevel.WARN, this.prefixes, message);
  }
  error(message: string, error?: Error) {
    if (error) {
      message += "\n" + error.toString();
    }

    this.logMessage(LoggerLevel.ERROR, this.prefixes, message);
  }

  private pad(value: number, size: number) {
    let numString = value.toString();

    while (numString.length < size) {
      numString = "0" + numString;
    }

    return numString;
  }

  private getTime() {
    const d = new Date();
    const hours = this.pad(d.getHours(), 2);
    const minutes = this.pad(d.getMinutes(), 2);
    const seconds = this.pad(d.getSeconds(), 2);
    const milliseconds = this.pad(d.getMilliseconds(), 3);

    return `${hours}:${minutes}:${seconds},${milliseconds}`;
  }

  private logMessage(level: LoggerLevel, prefixes: string[], message: string) {
    let line = this.getTime();
    let levelString = level.toString();
    line += " - " + levelString.toUpperCase();
    if (prefixes.length > 0) {
      line += " - " + prefixes.join(" ");
    }
    line += " " + message;
    (console as any)[levelString].call(console, line);
  }
}

export function loggerCreator(
  prefix: string,
  parent?: Logger,
  printOnCreationLevel: LoggerLevel = LoggerLevel.INFO,
  printOnCreation = DEFAULT_CREATION_MESSAGE
) {
  return new Logger(prefix, parent, printOnCreation, printOnCreationLevel);
}



// WEBPACK FOOTER //
// ./app/utils/logger.ts